<template>
  <input type="text" inputmode="numeric" pattern="[0-9]*" maxlength="10" :aria-label="label"
    :value="draft" :disabled="disabled" @focus="editing = true" @input="onInput" @blur="commit" @keydown.enter.prevent="commit">
</template>

<script>
import commerce from '@/utils/pcCommerce'

export default {
  name: 'QuantityInput',
  props: {
    value: { type: [Number, String], default: 1 },
    min: { type: [Number, String], default: 1 },
    max: { type: [Number, String], default: 2147483647 },
    disabled: Boolean,
    label: { type: String, default: '采购数量' }
  },
  data() { return { draft: String(commerce.normalizeQuantity(this.value, this.min, this.max)), editing: false } },
  watch: {
    value(value) { if (!this.editing) this.draft = String(commerce.normalizeQuantity(value, this.min, this.max)) },
    min() { this.commit() },
    max() { this.commit() }
  },
  methods: {
    onInput(event) {
      const raw = event.target.value
      if (!/^\d*$/.test(raw)) { event.target.value = this.draft; return }
      this.draft = raw
      if (!raw) return
      const count = Number(raw)
      if (Number.isSafeInteger(count) && count !== Number(this.value)
          && count === commerce.normalizeQuantity(count, this.min, this.max)) this.$emit('input', count)
    },
    commit() {
      this.editing = false
      const count = commerce.normalizeQuantity(this.draft, this.min, this.max)
      this.draft = String(count)
      if (count !== Number(this.value)) this.$emit('input', count)
    }
  }
}
</script>
